/**
 * @generated SignedSource<<06af17a89c45ba81328bc6acc12970b6>>
 * @relayHash 2e65e91f973b80aa33359c025ddf81a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 77dcf45d142c697ffdd43103256587365d38330f7009874092b2ee7f4a8216ce

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceTeamAdminControlsMode = "ALL_TEAMS" | "MEMBER_MANAGED_TEAMS" | "NO_TEAMS" | "VERIFIED_TEAMS" | "%future added value";
export type useTeamPickerQuery$variables = {
  cloudId: string;
};
export type useTeamPickerQuery$data = {
  readonly confluence_teamAdminControlsSettings: {
    readonly teamAdminControlsMode: ConfluenceTeamAdminControlsMode | null | undefined;
  } | null | undefined;
};
export type useTeamPickerQuery = {
  response: useTeamPickerQuery$data;
  variables: useTeamPickerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceTeamAdminControlsSettings",
    "kind": "LinkedField",
    "name": "confluence_teamAdminControlsSettings",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "teamAdminControlsMode"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useTeamPickerQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTeamPickerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2e65e91f973b80aa33359c025ddf81a0",
    "id": "77dcf45d142c697ffdd43103256587365d38330f7009874092b2ee7f4a8216ce",
    "metadata": {},
    "name": "useTeamPickerQuery",
    "operationKind": "query",
    "text": "query useTeamPickerQuery($cloudId:ID!){confluence_teamAdminControlsSettings(cloudId:$cloudId){teamAdminControlsMode}}"
  }
};
})();

(node as any).hash = "f35bcbb3a9ec452df1f7352ea21732d6";

export default node;
